import { defineStore } from 'pinia';
import {userStoreActions, userStoreGetters} from '@/shared/helpers/userStoreHelper.js';
import {useUiStore} from '@/shared/stores';

export const useUserStore = defineStore('user', {
	state: () => ({
		user: null,
		businesses: null,
		currBusinessId: null,
	}),
	getters: {
		darkMode() {
			return useUiStore().darkMode;
		},
		currBusiness: state => {
			return userStoreGetters.currBusiness(state);
		},
		normalizedUser: state => {
			return userStoreActions.normalizeUser(state.user)
		},
		currPermissions: state => {
			return userStoreGetters.currPermissions(state);
		},
	},
	actions: {
		logout(callback = null) {
			userStoreActions.logout(callback);
		},
		init(redirectUrlAuth = null, kickIfNotLogged = true) {
			userStoreActions.init(this, redirectUrlAuth, kickIfNotLogged);
		},
		initDarkMode() {
			useUiStore().initDarkMode();
		},
		normalizeBusiness(business) {
			return userStoreActions.normalizeBusiness(business);
		},
		normalizeAddress(address) {
			return userStoreActions.normalizeAddress(address);
		},
		refreshUserAccount(callback = null) {
			userStoreActions.refreshUserAccount(this, callback);
		},
		refreshBusiness(businessId, callback = null) {
			userStoreActions.refreshBusiness(this, businessId, callback);
		},
		getBusinessUsers(callback = null) {
			userStoreActions.getBusinessUsers(this, callback);
		},
		changeBusinessCountryConsoleLink(businessCountry) {
			return userStoreActions.changeBusinessCountryConsoleLink(businessCountry);
		},
	},
});
